module.exports = __webpack_public_path__ + "irimia.png?abe79b96587c1eb0945d9cce57dd22f0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/irimia.png
// module id = 250
// module chunks = 0